import { useRef, useState } from 'react'
import cn from 'classnames'
import { ContentSteps } from 'src/lib/useStepFlow'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'
import Ring from 'src/icons/ring.webp'
import Light1 from 'src/icons/light-1.webp'
import Light2 from 'src/icons/light-2.webp'
import Star from 'src/icons/star.webp'
import WheelBtn from 'src/icons/wheel-btn.webp'
import { texts } from './text-first-step'
import { TLang } from 'src/constants/langs'
import { imageWheelDataMap, textBtn } from './mock'
import cls from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const FirstStep = ({ onNext, step, lang }: TProps) => {
    const { header } = useLocalizedText(lang, texts)
    const [rotated, setRotated] = useState(false)
    const [lightsOn, setLightsOn] = useState(false)
    const [goodBye, setGoodBye] = useState(false)

    const textBtnByLang = lang === 'ro' || lang === 'el' ? lang : 'en'

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    function getImageWheelDataByLang(lang: TLang) {
        return imageWheelDataMap[lang] || imageWheelDataMap['en']
    }

    const btnRef = useRef<HTMLImageElement>(null)

    const handleClick = () => {
        if (rotated) return

        setRotated(true)

        const btn = btnRef.current
        if (btn) {
            const style = window.getComputedStyle(btn)
            const matrix = new DOMMatrixReadOnly(style.transform)
            const currentScale = matrix.a

            btn.style.animation = 'none'
            btn.style.transform = `translate(-50%, -50%) scale(${currentScale})`

            requestAnimationFrame(() => {
                btn.style.transition = 'transform 0.5s ease-in-out'
                btn.style.transform = 'translate(-50%, -50%) scale(1)'
            })
        }
        setTimeout(() => {
            setLightsOn(true)
            setTimeout(() => {
                setGoodBye(true)
                setTimeout(() => {
                    onNext(step)
                }, 300)
            }, 2000)
        }, 2000)
    }

    return (
        <div className={cls.root}>
            <div className={cls.text_wrapper}>{header}</div>
            <div className={cn(cls.wheel_wrapper, { [cls.good_bye]: goodBye })}>
                <img src={Ring} alt="Ring" className={cls.ring} />
                <img
                    src={getImageWheelDataByLang(lang)}
                    alt="WheelData"
                    className={cn(cls.wheel_data, cls.calm_state, {
                        [cls.rotate]: rotated,
                    })}
                />
                <img
                    src={Light1}
                    alt="Light1"
                    className={cn(cls.lights, cls.lights_1, {
                        [cls.flash]: lightsOn,
                    })}
                />
                <img
                    src={Light2}
                    alt="Light2"
                    className={cn(cls.lights, cls.lights_2, {
                        [cls.flash]: lightsOn,
                    })}
                />
                <div
                    ref={btnRef}
                    className={cn(cls.wrapper_btn, {
                        [cls.btn_pulse]: !rotated,
                    })}
                    onClick={handleClick}
                >
                    <img
                        src={WheelBtn}
                        alt="WheelBtn"
                        className={cls.wheel_btn}
                    />
                    <span
                        className={cn(
                            cls.text_btn,
                            cls[`text_btn__${textBtnByLang}`],
                            {
                                [cls.text_btn_rotated]: rotated,
                            }
                        )}
                    >
                        {getBtnTextByLang()}
                    </span>
                </div>

                <img
                    src={Star}
                    alt="Star"
                    className={cn(cls.star, { [cls.jumping]: lightsOn })}
                />
            </div>
        </div>
    )
}
